import { useEffect, useState } from "react";
import { Text, View, StyleSheet, ViewStyle, Pressable } from "react-native";
import { Colors } from "@/constants";
import { ms } from "@/ui/moderateScale";
import Icon from "@/ui/Icon";
import { useUISlice } from "@/models/useUISlice";

const CheckboxButton = ({
  value = false,
  containerStyle = {},
  onCheckboxChange,
  color = Colors.subtitle,
  title,
  subtitle,
  disabled = false,
  isRight = false,
}: {
  value?: boolean;
  onCheckboxChange: (active: boolean) => void;
  color?: string;
  containerStyle?: ViewStyle;
  title: string;
  isRight?: boolean;
  disabled?: boolean;
  subtitle?: string;
}) => {
  const [checkBoxActive, setCheckboxActive] = useState(false);
  const [active, setActive] = useState(false);
  const width = useUISlice((state) => state.device.width);

  useEffect(() => {
    setCheckboxActive(value);
  }, [value]);

  return (
    <Pressable
      disabled={disabled}
      onHoverIn={() => setActive(true)}
      onHoverOut={() => setActive(false)}
      style={StyleSheet.flatten([
        {
          cursor: "pointer",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        },
        containerStyle,
      ])}
      onPress={() => {
        setCheckboxActive(!checkBoxActive);
        onCheckboxChange(!checkBoxActive);
      }}
    >
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: isRight ? "space-between" : "flex-start",
        }}
      >
        {!isRight && (
          <View
            style={{
              ...s.checkbox,
              backgroundColor: checkBoxActive ? Colors.accent : Colors.white,
              borderColor: active
                ? Colors.accent
                : checkBoxActive
                  ? Colors.accent
                  : color,
            }}
          >
            <Icon icon="tick" style={s.checkboxIcon} />
          </View>
        )}

        <View style={{ marginLeft: isRight ? 0 : ms(8) }}>
          <Text
            style={{
              fontSize: ms(16),
              fontWeight: "400",
              color: Colors.text,
              maxWidth: Math.min(width * 0.7, ms(400)),
            }}
          >
            {title}
          </Text>

          {subtitle && (
            <View style={{ flexDirection: "row" }}>
              <Text
                style={{
                  fontSize: ms(12),
                  lineHeight: ms(16),
                  color: Colors.subtitle,
                }}
              >
                {subtitle}
              </Text>
            </View>
          )}
        </View>

        {isRight && (
          <View
            style={{
              ...s.checkbox,
              backgroundColor: checkBoxActive ? Colors.accent : Colors.white,
              borderColor: active
                ? Colors.accent
                : checkBoxActive
                  ? Colors.accent
                  : color,
            }}
          >
            <Icon icon="tick" style={s.checkboxIcon} />
          </View>
        )}
      </View>
    </Pressable>
  );
};
const s = StyleSheet.create({
  checkbox: {
    width: ms(18),
    height: ms(18),
    borderWidth: ms(1.5),
    borderRadius: ms(4),
    alignItems: "center",
    justifyContent: "center",
    borderColor: Colors.subtitle,
  },
  checkboxIcon: {
    tintColor: Colors.white,
    width: ms(12),
    height: ms(12),
  },
});

export default CheckboxButton;
